// extracted by mini-css-extract-plugin
export default {"container":"annual-sub-info-module--container--3QMFG"};